import { isMobileDevice } from "@stepapp/core";
import { Block, Image, palette, spacing, Touchable, Typography } from "@stepapp/ui";
import { useTranslation } from "react-i18next";
import { Linking, StyleSheet } from "react-native";
import { promoBanner } from "../assets/images";
import { useAppLinks } from "../hooks";

const PromoBanner = () => {
  const { t } = useTranslation();
  const { AppLanding, AppCustomer } = useAppLinks();

  return (
    <Block row borderRadius={1} marginVertical={2} paddingHorizontal={4} style={styles.container}>
      <Block alignCenter justifyCenter flex={1}>
        <Touchable
          onPress={() => Linking.openURL(isMobileDevice ? AppCustomer : AppLanding)}
          style={styles.text}
        >
          <Typography center shadow type="white">
            <Typography type="primaryLink">{t("screens.bookedServices.downloadApp")}</Typography>
            {t("screens.bookedServices.toTrackProgress")}
          </Typography>
        </Touchable>
      </Block>

      <Block height={12} style={styles.image} width={20}>
        <Image height={spacing.unit * 12} source={promoBanner} width={spacing.unit * 20} />
      </Block>
    </Block>
  );
};

export default PromoBanner;

const styles = StyleSheet.create({
  container: {
    backgroundColor: palette.primary.accent,
    minHeight: spacing.unit * 12,
  },
  image: {
    position: "absolute",
    right: spacing.unit * 2,
    zIndex: -1,
  },
  text: {
    width: "100%",
  },
});
